// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "desktop_NewBuildingSearchRoute" + "_" + "869167a426ef0f166349" + ".css";
};